const en = {
    global: {
        menu: {
            services_3pl: '3PL SERVICES',
            services_ecommerce: 'ECOMMERCE FULFILLMENT SERVICES',
            benefits: 'BENEFITS',
            pricing: 'PRICING',
            contacts: 'CONTACTS',
            login: 'LOG IN',
            profile: 'Boxiti user environment',
            sign_out: 'Sign out',
            try_it: 'TRY IT'
        }
    }
}

const lt = {
    global: {
        menu: {
            services_3pl: '3PL PASLAUGOS',
            services_ecommerce: 'EL. PARDUOTUVIŲ SĄSAJA',
            benefits: 'PRIVALUMAI',
            pricing: 'KAINOS',
            contacts: 'KONTAKTAI',
            login: 'PRISIJUNGTI',
            profile: 'Mano Boxiti aplinka',
            sign_out: 'Atsijungti',
            try_it: 'IŠBANDYTI'
        }
    }
}

export default {en, lt}



// WEBPACK FOOTER //
// ./src/i18n/global.js